var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarEyes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7612 14.908C30.5905 12.348 25.9998 4 15.9998 4C5.99983 4 1.40916 12.348 0.238495 14.908C0.081346 15.2511 0 15.624 0 16.0013C0 16.3787 0.081346 16.7516 0.238495 17.0947C1.40916 19.652 5.99983 28 15.9998 28C25.9998 28 30.5905 19.652 31.7612 17.092C31.918 16.7493 31.9992 16.3769 31.9992 16C31.9992 15.6231 31.918 15.2507 31.7612 14.908ZM15.9998 25.3333C7.5905 25.3333 3.6665 18.1787 2.6665 16.0147C3.6665 13.8213 7.5905 6.66667 15.9998 6.66667C24.3892 6.66667 28.3145 13.7907 29.3332 16C28.3145 18.2093 24.3892 25.3333 15.9998 25.3333Z",
    fill: "url(#paint0_linear_3591_14831)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 9.33301C14.6811 9.33301 13.3922 9.724 12.2959 10.4565C11.1995 11.1891 10.3451 12.2303 9.84048 13.4485C9.3359 14.6666 9.20387 16.0071 9.46111 17.3003C9.71834 18.5935 10.3533 19.7814 11.2856 20.7137C12.218 21.6461 13.4059 22.281 14.6991 22.5382C15.9923 22.7955 17.3327 22.6635 18.5509 22.1589C19.7691 21.6543 20.8103 20.7998 21.5428 19.7035C22.2754 18.6071 22.6663 17.3182 22.6663 15.9997C22.6642 14.2322 21.9612 12.5378 20.7114 11.288C19.4616 10.0382 17.7671 9.33512 15.9997 9.33301ZM15.9997 19.9997C15.2086 19.9997 14.4352 19.7651 13.7774 19.3256C13.1196 18.886 12.6069 18.2613 12.3042 17.5304C12.0014 16.7995 11.9222 15.9952 12.0765 15.2193C12.2309 14.4434 12.6118 13.7307 13.1712 13.1712C13.7307 12.6118 14.4434 12.2309 15.2193 12.0765C15.9952 11.9222 16.7995 12.0014 17.5304 12.3042C18.2613 12.6069 18.886 13.1196 19.3256 13.7774C19.7651 14.4352 19.9997 15.2085 19.9997 15.9997C19.9997 17.0605 19.5782 18.078 18.8281 18.8281C18.078 19.5782 17.0605 19.9997 15.9997 19.9997Z",
    fill: "url(#paint1_linear_3591_14831)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3591_14831",
    x1: 4.13366e-7,
    y1: 30.5714,
    x2: 34.436,
    y2: 20.4041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#7DA1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645919,
    stopColor: "#E16CB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999152,
    stopColor: "#E65B8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3591_14831",
    x1: 9.33301,
    y1: 24.0949,
    x2: 24.2033,
    y2: 20.8019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#7DA1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645919,
    stopColor: "#E16CB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999152,
    stopColor: "#E65B8B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarEyes);
export default __webpack_public_path__ + "static/media/avatar-eyes.f061d7248677808dcdd180e14bbabe5a.svg";
export { ForwardRef as ReactComponent };